import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";
import { APIResponse } from "./CommonApiSlice";

interface AddTopicPayload {
  name: string;
  duration: number;
  description: string | undefined;
}
export interface TopicItem {
  createdOn: string;
  lastUpdateOn: string;
  createdByName: string;
  createdByEmail: string;
  modifiedByName: string;
  modifiedByEmail: string;
  id: string;
  name: string;
  duration: number;
  description: string;
  chapterId: string;
  parentId: string;
  weight: number;
  type: string;
  searchKey: string;
}

export interface ChildItemforParent {
  _id: string;
  id: string;
  name: string;
  duration: number;
  topicId?: string;
  subjectId?: string;
  chapterId?: string;
  type: string;
  parentId: string;
  searchKey: string;
  createdOn: string;
  createdByName: string;
  createdByEmail: string;
  _class: string;
  hasChildren?: boolean;
}

export interface GetChildrenForParentResponse extends APIResponse {
  response: ChildItemforParent[];
}

export interface GetAllTopicsForChapter extends APIResponse {
  response: TopicItem[];
}
export type AddTopicResponse = APIResponse;
export type UpdateTopicResponse = APIResponse;
export type GetTopicsForMultipleChapters = GetAllTopicsForChapter;

export const TopicApiSlice = createApi({
  reducerPath: "topicApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllTopics: builder.query<GetAllTopicsForChapter, { chapterId: string }>({
      query: ({ chapterId }) => ({
        url: `topic?chapterId=${chapterId}`,
        method: "GET",
      }),
    }),
    addTopics: builder.mutation<
      AddTopicResponse,
      { payload: AddTopicPayload; chapterId: string }
    >({
      query: ({ chapterId, payload }) => ({
        url: `topic?chapterId=${chapterId}`,
        method: "POST",
        body: payload,
      }),
    }),
    getTopicsofMultipleChapters: builder.mutation<
      GetTopicsForMultipleChapters,
      string[]
    >({
      query: (chapterIds) => ({
        url: `topic/get`,
        method: "POST",
        body: chapterIds,
      }),
    }),
    getChildrenForParent: builder.mutation<
      GetChildrenForParentResponse,
      { resourceId: string[]; syllabusId: string }
    >({
      query: ({ resourceId, syllabusId }) => ({
        url: `tree/get-syllabus-children?syllabusId=${syllabusId}`,
        method: "POST",
        body: resourceId,
      }),
    }),
    updateTopic: builder.mutation<
      UpdateTopicResponse,
      { topicId: string; payload: { [key: string]: string } }
    >({
      query: ({ topicId, payload }) => ({
        url: `topic?topicId=${topicId}`,
        method: "PUT",
        body: payload,
      }),
    }),
  }),
});

export const {
  useAddTopicsMutation,
  useGetChildrenForParentMutation,
  useGetTopicsofMultipleChaptersMutation,
  useUpdateTopicMutation,
  useLazyGetAllTopicsQuery,
} = TopicApiSlice;
